import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set deadline to 2 days from now
    const deadline = new Date();
    deadline.setDate(deadline.getDate() + 2);
    deadline.setHours(23, 59, 59);
    const timer = setInterval(() => {
      const now = new Date();
      const difference = deadline.getTime() - now.getTime();
      if (difference <= 0) {
        clearInterval(timer);
        return;
      }
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(difference / (1000 * 60 * 60) % 24);
      const minutes = Math.floor(difference / 1000 / 60 % 60);
      const seconds = Math.floor(difference / 1000 % 60);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-red-600 text-white py-2 px-4 sticky top-0 z-50 shadow-md" data-id="element-1">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center" data-id="element-2">
        <div className="flex items-center gap-2 font-bold uppercase tracking-wider text-sm sm:text-base animate-pulse" data-id="element-3">
          <Clock size={18} data-id="element-4" />
          <span data-id="element-5">Oferta por tiempo limitado</span>
        </div>

        <div className="flex items-center gap-2 sm:gap-4 font-mono font-bold text-lg sm:text-xl" data-id="element-6">
          <div className="flex flex-col items-center leading-none" data-id="element-7">
            <span data-id="element-8">{String(timeLeft.days).padStart(2, '0')}</span>
            <span className="text-[10px] font-sans font-normal opacity-80" data-id="element-9">
              DÍAS
            </span>
          </div>
          <span data-id="element-10">:</span>
          <div className="flex flex-col items-center leading-none" data-id="element-11">
            <span data-id="element-12">{String(timeLeft.hours).padStart(2, '0')}</span>
            <span className="text-[10px] font-sans font-normal opacity-80" data-id="element-13">
              HRS
            </span>
          </div>
          <span data-id="element-14">:</span>
          <div className="flex flex-col items-center leading-none" data-id="element-15">
            <span data-id="element-16">{String(timeLeft.minutes).padStart(2, '0')}</span>
            <span className="text-[10px] font-sans font-normal opacity-80" data-id="element-17">
              MIN
            </span>
          </div>
          <span data-id="element-18">:</span>
          <div className="flex flex-col items-center leading-none" data-id="element-19">
            <span data-id="element-20">{String(timeLeft.seconds).padStart(2, '0')}</span>
            <span className="text-[10px] font-sans font-normal opacity-80" data-id="element-21">
              SEG
            </span>
          </div>
        </div>
      </div>
    </div>;
}